$(document).ready(function () {
  $(".main-contewnt").slick({
    dots: false,
    infinite: true,
    speed: 300,
    nextArrow:true,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    prevArrow: $(".icon-main-asidew .slide-prev"),
    nextArrow: $(".icon-main-asidew .slide-next"),
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
    ]
  });
});

$(document).ready(function () {
  $(".main-contewnt12").slick({
    dots: false,
    infinite: false,
    speed: 300,
    nextArrow:true,
    slidesToShow: 3,
    slidesToScroll: 3,
    infinite: true,
    prevArrow: $(".icon-main-asidew23 .slide-prev"),
    nextArrow: $(".icon-main-asidew23 .slide-next"),
  });
});
$(document).ready(function () {
  $(".banner-slider-one").slick({
    dots: false,
    infinite: false,
    speed: 300,
    nextArrow:true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: $(".main-icon-banner .slide-prev"),
    nextArrow: $(".main-icon-banner .slide-next"),
  });
});
$(document).ready(function () {
  $(".main-client-content").slick({
    dots: false,
    infinite: false,
    speed: 300,
    nextArrow:true,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: $(".icon-main-asidew23 .slide-prev"),
    nextArrow: $(".icon-main-asidew23 .slide-next"),
  });
});


